module.exports = __webpack_public_path__ + "img/IMG_1867_L_Foamcore.0da4a072.jpg";